<template>
  <div class="minW1060-auto bg-fff mag10 pad10">
    <el-row class="text-left">
      <div class="dlblock-mb20 mr10">
        <el-input v-model.trim="searchValue" placeholder="请输入" style="width: 200px;"/>
      </div>
      <div class="dlblock-mb20">
        <el-button type="primary" @click="editBtn(1)">
          搜索
        </el-button>
        <el-button type="primary" @click="editBtn(2)">
          上传图片
        </el-button>
        <el-button type="primary" @click="editBtn(3)">
          标签库管理
        </el-button>
      </div>
    </el-row>

    <div class="m-wrap" v-loading="imgListLoading">
      <div class="m-box" v-for="(item, index) in imgList" :key="index">
        <el-image class="m-box-img" :src="item.pictureUrl" @click="editBtn(4, item)" lazy></el-image>

        <div class="m-box-title">
          <el-button class="overFont wp100">{{item.labelName || '添加标签'}}</el-button>
        </div>

        <span class="m-box-del el-icon-circle-close" @click.stop="editBtn(5, item)"></span>
      </div>
    </div>

    <div class="my-pagination">
      <el-pagination background layout="total, prev, pager, next" :total="pages.total"
                     :current-page="pages.page" @current-change="pageChange">
      </el-pagination>
    </div>

    <!-- 图片放大 -->
    <el-dialog title="查看" :visible.sync="imgPreData.modal" width="800px">
      <img style="width: 100%; height: auto;" :src="imgPreData.url" alt="">
    </el-dialog>

    <!-- 图片上传 -->
    <el-dialog title="上传图片" :visible.sync="imgUploadData.modal" width="800px">
      <el-row>
        <more-img class="mr10 mb10" v-model="imgUploadData.urlList" multiple :total="99"/>
      </el-row>

      <div slot="footer">
        <el-button @click="imgUploadData.modal = false">取 消</el-button>
        <el-button type="primary" @click="uploadSave">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import MoreImg from '@/components/MoreImg.vue'

  import {
    getImagePage,
    delImage,
    addImage
  } from '@/api'

  export default {
    name: 'Gallery',
    components: {MoreImg},
    data () {
      return {
        searchValue: '',
        imgTotal: 0,
        imgList: [],
        imgListLoading: false,
        pages: {
          page: 1,
          total: 0
        },
        // 图片放大
        imgPreData: {
          modal: false,
          url: ''
        },
        // 图片上传
        imgUploadData: {
          modal: false,
          urlList: []
        }
      }
    },
    created () {
      this.getImagePageFn()
    },
    methods: {
      uploadSave () {
        if (this.imgUploadData.urlList && this.imgUploadData.urlList.length) {
          addImage(this.imgUploadData.urlList.map(item => ({pictureUrl: item}))).then(res => {
            this.$message.success(res.data)
            this.imgUploadData.modal = false
            this.getImagePageFn()
          })
        }
      },
      // t: 1分页查询 2上传图片 3标签库管理 4放大图片 5删除图片
      editBtn (t, row) {
        switch (t) {
          case 1:
            this.pages.page = 1
            this.getImagePageFn()
            break

          case 2:
            this.imgUploadData = {
              modal: true,
              urlList: []
            }
            break

          case 3:
            break

          case 4:
            this.imgPreData = {
              modal: true,
              url: row.pictureUrl
            }
            break

          case 5:
            this.$confirm('确认删除吗?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              delImage(row.pictureId).then(res => {
                this.$message.success(res.data)
                this.getImagePageFn()
              })
            }).catch(() => {
            })
            break
        }
      },
      getImagePageFn () {
        this.imgListLoading = true
        getImagePage({
          labelName: this.searchValue,
          pageNum: this.pages.page,
        }).then(res => {
          this.imgList = res.data.list
          this.pages.total = res.data.count
        }).finally(() => {
          this.imgListLoading = false
        })
      },
      pageChange (val) {
        this.pages.page = val
        this.getImagePageFn()
      },
    }
  }
</script>

<style scoped>
  .m-wrap {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  .m-box {
    width: 240px;
    position: relative;
    margin: 10px;
  }

  .m-box:hover {
    transform: translateY(-2px);
  }

  .m-box:hover .m-box-del {
    display: block;
  }

  .m-box-img {
    width: 100%;
    height: 160px;
    cursor: pointer;
  }

  .m-box-title {
  }

  .m-box-del {
    display: none;
    position: absolute;
    top: -10px;
    right: -10px;
    font-size: 24px;
    color: #ffffff;
    background: rgba(0, 0, 0, .2);
    border-radius: 50%;
    cursor: pointer;
  }
</style>
